import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from "@mui/material/Grid/Grid";

export default (data, key) => {
    return (
        <Grid item md={12} xs={12} key={key} className={data.classList}>
            <FormControl>
                <InputLabel shrink htmlFor="select-multiple-native">
                    {data.headerName}
                </InputLabel>
                <Select
                    multiple={true}
                    native
                    name={data.name}
                    value={data.value}
                    // @ts-ignore Typings are not considering `native`
                    onChange={data.handleChange}
                    label={data.headerName}
                    inputProps={{
                        id: 'select-multiple-native',
                    }}
                >
                    {data.items.map((item, ind) => (
                        <option key={ind} value={item}>
                            {item}
                        </option>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    );
}